import { render } from "./provisionExtension.vue?vue&type=template&id=524c0882&scoped=true"
import script from "./provisionExtension.vue?vue&type=script&lang=js"
export * from "./provisionExtension.vue?vue&type=script&lang=js"

import "./provisionExtension.vue?vue&type=style&index=0&id=524c0882&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524c0882"]])

export default __exports__